/* esm.sh - react-qr-code@2.0.21 */
export * from "/*react-qr-code@2.0.21/esnext/react-qr-code.mjs";
export { default } from "/*react-qr-code@2.0.21/esnext/react-qr-code.mjs";
